
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('Comments', function (Parse, Profiles) {

		// ==================================================
		// Load object schema
		// ==================================================
		let ProjectComment = Parse.Object.extend('Project_Comments');

		// ==================================================
		// Methods
		// ==================================================


		/**
		 * Create a new comment object on the database
		 */
		this.post = function(options) {

			// Create a new instance of a project comment
			let comment = new ProjectComment(options);

			// Find current user profile
			comment.set('author', Profiles.getCurrent());

			// Save the comment
			return comment.save();

		};
		
	});
}




// WEBPACK FOOTER //
// ./src/app/core/services/comments.service.js